import React, {useCallback, useState} from "react"
import {observer} from "mobx-react";
import moment from 'moment'
import SessionStore from "../../stores/SessionStore";
import ReportStore from "../../stores/ReportStore";
import {api} from "../../config";
import ScheduleStore from "../../stores/ScheduleStore";
import ReactDataGrid from "@inovua/reactdatagrid-community";
import DateFilter from "@inovua/reactdatagrid-community/DateFilter";

const filterValue = [
  { name: 'appointmentDate', operator: 'equals', type: 'date', value: null},
  { name: 'name', operator: 'contains', type: 'string', value:''},
  { name: 'email', operator: 'contains', type: 'string', value:''},
  { name: 'location', operator: 'contains', type: 'string', value:''},
];

const gridStyle = { minHeight: 500 };

const ExamAccommodations = observer((props) => {

  const [skip, setSkip] = useState(0);
  const [limit, setLimit] = useState(50);
  const [filterObject, setFilterObject] = useState(filterValue);

  // eslint-disable-next-line
  const [update, setUpdate] = useState(false);
  const [sort, setSort] = useState(null);


  const renderAccommodation = (acc, data) => {

    if(data[acc.key].info)  {
      return(
        <div style={{ margin:'10px'}}><b>{acc.label}: </b>{data[acc.key].info}<br/></div>
      )
    } else if(typeof data[acc.key] === "string" || typeof data[acc.key] === "number") {
      return (
        <div style={{ margin:'10px'}}><b>{acc.label}: </b>{data[acc.key]}<br/></div>
      )
    } else if(data[acc.key].permitted) {
      return (
        <div style={{ margin:'10px'}}><b>{acc.label}: </b>Allowed<br/></div>
      )
    } else {
      return (
        <div style={{ margin:'10px'}}><b>{acc.label}: </b>Not Allowed<br/></div>
      )
    }
  }

  const columns = [
    {
      name: 'name',
      header: "Student",
      type: 'string',
      defaultFlex: 1,
      enableColumnFilterContextMenu: false,
      render: ({ data }) => {
        return <span>{data.firstName} {data.lastName}</span>;
      }
    },
    {
      name: 'email',
      header: "Student Email",
      type: 'string',
      defaultFlex: 1.5,
      defaultVisible: true,
      enableColumnFilterContextMenu: false,
      render: ({ data }) => {
        return <span>{data.email}</span>;
      }
    },
    {
      name: 'appointmentDate',
      header: 'Appointment Date',
      defaultFlex: 1,
      filterEditor: DateFilter,

      dateFormat: 'MM/DD/YYYY',
      render: ({ data }) => {
        return <span>{moment(data.appointmentDate).format('MM/D/YYYY')}</span>;
      },
      enableColumnFilterContextMenu: false,
    },
    {
      name: 'location',
      header: `Location`,
      type: "string",
      defaultFlex: 2,
      enableColumnFilterContextMenu: false,
    },
    {
      name: 'accommodations',
      header: 'Accommodations',
      defaultFlex: 3,
      render: ({data}) => {
        // Define the accommodations you want to check
        const accommodations = [
          {key: 'textbook', label: 'Textbook'},
          {key: 'calculator', label: 'Calculator'},
          {key: 'bathroom', label: 'Bathroom Breaks'},
          {key: 'paper', label: 'Paper'},
          {key: 'formulaSheet', label: 'Formula Sheet'},
          {key: 'notes', label: 'Notes'},
          {key: 'dictionary', label: 'Dictionary'},
          {key: 'websites', label: 'Websites'},
          {key: 'earplugs', label: 'Earplugs'},
          {key: 'duration', label: 'Duration'},
          {key: 'proctorNotes', label: 'Proctor Notes'},
          {key: 'studentNotes', label: 'Student Notes'},
          {key: 'examOpen', label: 'Exam Open Date'},
          {key: 'examClose', label: 'Exam Close Date'},
          {key: 'scheduleOpen', label: 'Schedule Open Date'},
          {key: 'scheduleClose', label: 'Schedule Close Date'},
          {key: 'otherItems', label: 'Other'},
        ];

        // Generate rows dynamically based on the accommodations

        const accommodationRows = accommodations
          .filter((acc) => {
            const entry = data[acc.key];
            if ((typeof entry === 'string' || typeof entry === 'number') && entry !== ""){
              if(acc.key === 'examClose' || acc.key ==='examOpen' || acc.key === 'scheduleOpen' || acc.key === 'scheduleClose'){
                data[acc.key] = moment(data[acc.key]).tz(moment.tz.guess()).format('MM/DD/YYYY hh:mm A')
              }
              return true;
            }
            else if (entry && typeof entry === 'object' && (entry.info.trim() !== "" || entry.permitted === true)) {
              return true;
            }
            return false;
          })
          .map((acc) => {
              return renderAccommodation(acc, data)
            }
          );

        return (
          <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', }}>
            {accommodationRows.length > 0
              ? accommodationRows
              : (
                <div style={{ margin: '10px', }}>
                  This session has no accommodations.
                </div>
            )}
          </div>
        );
      }
    }
  ];


  const formatAppointmentDate = (date, addDay = false) => {
    const dateString = moment(date).format('YYYY-MM-DD HH:mm');
    const timezoneString = moment(date).local().tz(moment.tz.guess()).format('Z');
    let newDate = moment.utc(`${dateString} ${timezoneString}`, 'YYYY-MM-DD HH:mm Z')
      .tz(moment.tz.guess())
      .toISOString();

    if (addDay) {
      return moment(newDate).add(1, 'd').toISOString();
    } else return newDate;
  }

  const loadData = ({skip, limit}) => {
    setLimit(limit);
    setSkip(skip);
    let query = '?limit=' + limit;
    if(skip) query += ('&offset=' + skip);


    filterObject.map(object => {
      if((object.value && object.value.length > 0 ) || object.name === "appointmentDate"){
        switch (object.name){
          case "appointmentDate":
              if(object.value){
                query += `&appointmentStartDate=${formatAppointmentDate(object.value)}`
              }
            break;
          case "location":
            query += `&location=${object.value}`
            break;
          case "name":
            query+= `&name=${object.value}`
            break;
          case "email":
            query+= `&email=${object.value}`
            break;
          default:
            break;
        }
      }
      return null;
    })
    let url = `/proctors/${SessionStore.userData.proctorAccountSid}/session-accommodations${query}`
    ReportStore.reportUrl = url;


    return api.get(url).then(response => {
      console.log(response);
      return {data: response.data.results || [], count: response.data.total || 0};
    })
  }

  let dataSource = useCallback(loadData, [skip, filterObject, limit, ScheduleStore.session, update, sort])

  return (
    <main tabIndex="0" id="main-content" className="page fill">
      <div className='fill'>
        <div class="split-row-container">
          <div className="left">
            <h1>Session Accommodations</h1>
          </div>
          <div className='right'>
          </div>
        </div>


        <ReactDataGrid
          className="reactDataGrid fill"
          style={gridStyle}
          idProperty="id"
          columns={columns}
          dataSource={dataSource}
          defaultFilterValue={filterValue}
          onFilterValueChange={setFilterObject}
          onSortInfoChange={setSort}
          onSkipChange={setSkip}
          onLimitChange={setLimit}
          limit={limit}
          skip={skip}
          resizable
          //onRowClick={onRowClick}
          pagination={true}
          rowHeight={({ data }) => {
            const textLength = data.description.length;
            if (textLength > 150) return 100; // Larger height for long descriptions
            if (textLength > 50) return 70; // Medium height for moderate descriptions
            return 40; // Default height for short descriptions
          }}
        />
      </div>
    </main>
  )
}); export default (ExamAccommodations);




// WEBPACK FOOTER //
// ./src/app/components/Reports/ExamAccommodations.js